import React, {useEffect, useState} from 'react';
import SideBar from "../../../common/SideBar";
import NavBar from "../../../common/NavBar";
import {Link} from "react-router-dom";
import Spinner from "reactjs-simple-spinner";
import FilesService from "../../../services/FilesService";
import {toast, ToastContainer} from "react-toastify";
import EmployerService from "../../../services/EmployerService";
import {MenuItem, TextField} from "@material-ui/core";
import PaymentsService from "../../../services/PaymentsService";

const BulkPayments = (props) => {
    const [loading, setLoading] = useState(false);
    const [uploadLoading, setUploadLoading] = useState(false);
    const [user, setUser] = useState(JSON.parse(localStorage.getItem('user')))
    const [aggregators, setAggregators] = useState([]);
    const [currencies, setCurrencies] = useState([])
    const [payload, setPayload] = useState({
        aggregator_id: null,
        currency_id: null,
        payment_channel: null,
        reference_number: ''
    })

    useEffect(() => {
        setLoading(true)
        const u = JSON.parse(localStorage.getItem('user'))
        let token = JSON.parse(localStorage.getItem('token'));
        setUser(u)
        console.log('user: ', u)
        console.log('token: ', JSON.parse(localStorage.getItem('token')))
        EmployerService.getAllEmployers().then(response => {

            if (response === null || response === undefined) {
                setAggregators([]);
                setLoading(false)
            } else {
                console.log('Employers', response);
                setAggregators(response);
                setLoading(false)
            }

        }).catch(err => {
            setAggregators([]);
            console.log(err);
            setLoading(false)
        });

        //    get all currencies
        PaymentsService.getAllCurrencies(token).then(response => {
            if (response.status === 200) {
                console.log("res: ", response)
                setCurrencies(response.data.currencies)
                setLoading(false);
            } else {
                setCurrencies([])
                setLoading(false);
            }
        }).catch(err => {
            console.error(err)
            setCurrencies([])
            setLoading(false);
        })


    }, [])

    const handleChange = name => ({target: {value}}) => {
        console.log("id", value)
        setPayload({...payload, [name]: value})

    }


    const handleImportBulkPayment = (e) => {
        setUploadLoading(true);

        if (payload.aggregator_id === null) {
            setUploadLoading(false);
            toast.warning('Please select aggregator');
            return;
        }

        if (payload.currency_id === null) {
            setUploadLoading(false);
            toast.warning('Please select currency');
            return;
        }

        if (payload.payment_channel === null) {
            setUploadLoading(false);
            toast.warning('Please select payment channel');
            return;
        }

        if (payload.reference_number === null) {
            setUploadLoading(false);
            toast.warning('Please input reference number');
            return;
        }


        //    import Bulk payment

        console.log("e: ", e.target.name);
        console.log(e.target.files);
        const file = e.target.files[0];
        const formData = new FormData();
        formData.append('paymentSchedule', file);
        formData.append('user_id', user.id);
        formData.append('currency_id', payload.currency_id);
        formData.append('payment_channel', payload.payment_channel);
        formData.append('reference_number', payload.reference_number);

        FilesService.bulkPaymentImport(formData, payload.aggregator_id)
            .then(res => {
                if (res.status === 200 || res.status === 201) {
                    console.log(res);
                    setUploadLoading(false);
                    toast.success('Payment successful');
                } else {
                    setUploadLoading(false);
                    toast.warning('Network Error, Try again \nIf error persists contact System Administrator ');
                }
            })
            .catch(err => {
                console.log(err);
                setUploadLoading(false);
                toast.warning('Network Error, Try again \nIf error persists contact System Administrator ');
            });
    }

    return (
        <>
            <div>
                <ToastContainer
                    position="top-center"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
                <SideBar roles={JSON.parse(localStorage.getItem('roles'))}/>
                <div id="main-content" className="main-panel ps-container ps-theme-default">
                  <NavBar roles={JSON.parse(localStorage.getItem('roles'))}/>
                    <div className="content">
                        <div className="container-fluid">
                            <ul className="breadcrumb">
                                <Link to="/dashboard"><a href><i className="fa fa-home"/>&nbsp;Dashboard</a> </Link>
                                 &nbsp;|&nbsp;
                                <Link to="/payments"><a href><i className="fa fa-credit-card"/>&nbsp;Payments</a>
                                </Link>
                                 &nbsp;|&nbsp;
                                <i className="fa fa-money"/>&nbsp;Bulk Payments
                            </ul>
                            {loading && (
                                <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                    <Spinner
                                        size="medium"
                                        message="Please wait....."
                                        line-fg-color="#64c3c2"
                                    />
                                </div>

                            )}
                            {uploadLoading && (
                                <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                    <Spinner
                                        size="medium"
                                        message="Uploading please wait....."
                                        line-fg-color="#64c3c2"
                                    />
                                </div>

                            )}
                            {!loading && !uploadLoading && (
                                <div className="row mt">
                                    <div className="card col-lg-12">
                                        <div className="content-panel bg-white">
                                            <div className="p-3"/>
                                            <div className="form-row p-5">
                                                <div className="form-group col-md-3">

                                                    <TextField
                                                        fullWidth
                                                        onChange={handleChange('aggregator_id')}
                                                        name="aggregator_id"
                                                        select
                                                        label="Select Aggregator"
                                                    >
                                                        <MenuItem value disabled={true}>Select Aggregator</MenuItem>
                                                        {aggregators.map((aggr, i) => (
                                                            <MenuItem key={i} value={aggr.id}>{aggr.name}</MenuItem>
                                                        ))}
                                                    </TextField>

                                                </div>
                                                <div className="form-group col-md-3">

                                                    <TextField
                                                        fullWidth
                                                        onChange={handleChange('currency_id')}
                                                        name="currency_id"
                                                        select
                                                        label="Select Currency"
                                                    >
                                                        <MenuItem value disabled={true}>Select Currency</MenuItem>
                                                        {currencies.map((currency, i) => (
                                                            <MenuItem key={i}
                                                                      value={currency.id}>{currency.code}</MenuItem>
                                                        ))}
                                                    </TextField>

                                                </div>
                                                <div className="form-group col-md-3">

                                                    <TextField
                                                        fullWidth
                                                        onChange={handleChange('payment_channel')}
                                                        name="payment_channel"
                                                        select
                                                        label="Select Payment Channel"
                                                    >
                                                        <MenuItem value disabled={true}>Select Payment
                                                            Channel</MenuItem>
                                                        <MenuItem value="CASH">Cash</MenuItem>
                                                        <MenuItem value="ECOCASH">Ecocash</MenuItem>
                                                        <MenuItem value="ONEMONEY">One Money</MenuItem>
                                                        <MenuItem value="TELECASH">Telecash</MenuItem>
                                                        <MenuItem value="RTGS">RTGS</MenuItem>
                                                        <MenuItem value="ZIPIT">ZIPIT</MenuItem>
                                                    </TextField>

                                                </div>
                                                <div className="form-group col-md-3">

                                                    <TextField
                                                        fullWidth
                                                        onChange={handleChange('reference_number')}
                                                        name="reference_number"
                                                        label="Reference Number"
                                                    />
                                                </div>
                                            </div>
                                            <div className="form-row p-5 mt-1">
                                                <div className="form-group col-md-6">
                                                    <label htmlFor="inputEmail4">
                                                        Import Bulk Payment</label>
                                                    <br/>
                                                    <em className="text-muted">* You can select file to upload</em>
                                                    &nbsp;&nbsp;
                                                    {/*<span style={{display: "none"}} id="uploadingLoader"/>*/}
                                                    {uploadLoading && (
                                                        <div className="mt-2 mb-2 p-1">
                                                            <Spinner
                                                                size="small"
                                                                message="Uploading File....."
                                                                line-fg-color="#64c3c2"
                                                            />
                                                        </div>

                                                    )}

                                                    <div>
                                                        {!uploadLoading && (
                                                            <label className="btn btn-sm btn-primary"
                                                                   htmlFor="my-file-selector1">
                                                                <input required
                                                                       id="my-file-selector1"
                                                                       type="file"
                                                                       name="paymentSchedule"
                                                                       style={{display: "none"}}
                                                                       accept=".xls,.xlsx,.ods"
                                                                       onChange={handleImportBulkPayment}
                                                                />
                                                                <i className="fa fa-credit-card-alt"/>&nbsp;&nbsp;
                                                                Import Payment Schedule
                                                            </label>
                                                        )}
                                                        <div className="p-3"/>
                                                        {/*{message && (*/}
                                                        {/*    <span className="form-control" id="upload-file-info"*/}
                                                        {/*          disabled>{message}</span>*/}
                                                        {/*)}*/}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="p-3"/>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default BulkPayments;
